<i class="fas fa-history snapshot-header-icon"></i>
<button type="button" class="close-button" aria-label="Close Dialog" (click)="closeDialog()">
  <svg-icon key="times" aria-hidden="true"></svg-icon>
</button>
<h3 class="snapshot-header" transloco="snapshot.dialog.title"
>Page History</h3>

<div class="snapshot-description" transloco="snapshot.dialog.description"
>Choose a version to go back to.</div>

<!--show this text when there is no snapshots-->
<div *ngIf="totalPages == 0" class="no-snapshots" transloco="snapshot.noResultFound">No results found</div>

<p-dataView [value]="currentSnapshots"
      [paginator]="showPaginator"
      [rows]="pageSize"
      [lazy]="true"
      [totalRecords]="totalSnapshots"
      [pageLinks]="3"
      (onLazyLoad)="paginateOnChange($event)"
      class="snapshot-dataview">

  <ng-template #list let-items>
    <div *ngFor="let snapshot of items; let rowIndex = index"
         class="page-snapshot-item"
         (click)="selectSnapshot(rowIndex)">
      {{ snapshot.date }}
    </div>
  </ng-template>
</p-dataView>
